import "./_bootstrap.js"
import { jarallax, jarallaxVideo } from "./silicon-theme/vendor/jarallax/dist/jarallax.min.js"
import vanillaTitle from "./silicon-theme/vendor/vanilla-tilt/dist/vanilla-tilt.min.js"
import stickyNavbar from "./silicon-theme/components/sticky-navbar"

function initEmailShareDialog() {
	const dialog = document.querySelector("#emailShareDialog")
	const triggerButtons = document.querySelectorAll("button[data-email-trigger='true']")
	const contentField = document.querySelector("#emailShareDialogContent")
	const copyButton = document.querySelector("#emailShareCopyButton")
	const targetLabel = document.querySelector("[data-email-dialog-target]")

	if (!dialog || !triggerButtons.length || !contentField || !copyButton || !targetLabel || typeof dialog.showModal !== "function") {
		return
	}

	const decode = (value) => {
		if (!value) {
			return ""
		}

		try {
			return decodeURIComponent(value)
		} catch (error) {
			return value
		}
	}

	const buildEmailDraft = (subject, body) => `Subject: ${subject}\n\n${body}`

	triggerButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const subject = decode(button.getAttribute("data-email-subject"))
			const body = decode(button.getAttribute("data-email-body"))
			const target = button.getAttribute("data-email-target") || "your team"

			targetLabel.textContent = target
			contentField.value = buildEmailDraft(subject, body)
			copyButton.textContent = "Copy to Clipboard"
			dialog.showModal()
		})
	})

	copyButton.addEventListener("click", async () => {
		const value = contentField.value
		if (!value) {
			return
		}

		try {
			await navigator.clipboard.writeText(value)
			copyButton.textContent = "Copied"
		} catch (error) {
			contentField.focus()
			contentField.select()
			copyButton.textContent = "Press Cmd+C to Copy"
		}
	})
}

function initConferenceVideoOverlay() {
	const conferenceVideo = document.querySelector("#conferenceVideo")
	const overlayButton = document.querySelector("[data-video-overlay-button='conference-video']")

	if (!conferenceVideo || !overlayButton) {
		return
	}

	overlayButton.addEventListener("click", () => {
		conferenceVideo.play()
		overlayButton.classList.add("d-none")
	})

	conferenceVideo.addEventListener("play", () => {
		overlayButton.classList.add("d-none")
	})

	conferenceVideo.addEventListener("ended", () => {
		overlayButton.classList.remove("d-none")
	})
}

function trackConferencePage() {
	const container = document.querySelector("[data-conference-slug]")
	if (!container) {
		return
	}

	const conferenceSlug = container.getAttribute("data-conference-slug") || "unknown"
	const pageParams = new URLSearchParams(window.location.search)

	if (typeof window.plausible === "function") {
		window.plausible("Conference Page View", {
			props: {
				conference: conferenceSlug,
				utm_source: pageParams.get("utm_source") || "",
				utm_medium: pageParams.get("utm_medium") || "",
				utm_campaign: pageParams.get("utm_campaign") || ""
			}
		})
	}

	const ctaLinks = document.querySelectorAll("[data-plausible-event]:not([href^='mailto:'])")
	ctaLinks.forEach((link) => {
		link.addEventListener("click", () => {
			if (typeof window.plausible !== "function") {
				return
			}

			const eventName = link.getAttribute("data-plausible-event")
			const rawProps = link.getAttribute("data-plausible-props")

			if (!eventName) {
				return
			}

			let parsedProps = {}
			if (rawProps) {
				try {
					parsedProps = JSON.parse(rawProps)
				} catch (error) {
					parsedProps = {}
				}
			}

			window.plausible(eventName, {
				props: {
					conference: conferenceSlug,
					...parsedProps
				}
			})
		})
	})

	const conferenceVideo = document.querySelector("[data-track-video]")
	if (!conferenceVideo) {
		return
	}

	let playedTracked = false
	let halfwayTracked = false
	let completedTracked = false

	conferenceVideo.addEventListener("play", () => {
		if (typeof window.plausible !== "function") {
			return
		}

		if (playedTracked) {
			return
		}

		playedTracked = true
		window.plausible("Conference Video Play", {
			props: {
				conference: conferenceSlug
			}
		})
	})

	conferenceVideo.addEventListener("timeupdate", () => {
		if (typeof window.plausible !== "function") {
			return
		}

		if (!halfwayTracked && conferenceVideo.duration > 0 && (conferenceVideo.currentTime / conferenceVideo.duration) >= 0.5) {
			halfwayTracked = true
			window.plausible("Conference Video 50", {
				props: {
					conference: conferenceSlug
				}
			})
		}
	})

	conferenceVideo.addEventListener("ended", () => {
		if (typeof window.plausible !== "function") {
			return
		}

		if (completedTracked) {
			return
		}

		completedTracked = true
		window.plausible("Conference Video Complete", {
			props: {
				conference: conferenceSlug
			}
		})
	})
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		initEmailShareDialog()
		initConferenceVideoOverlay()
		trackConferencePage()
	})
} else {
	initEmailShareDialog()
	initConferenceVideoOverlay()
	trackConferencePage()
}
